import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, Gift, Heart } from 'lucide-react';
import './DonationFeatures.css';

const DonationFeatures = () => {
  const { t } = useTranslation();
  const features = [
    { icon: ShieldCheck, title: t('donation_feature_secure_title'), description: t('donation_feature_secure_description') },
    { icon: Gift, title: t('donation_feature_tax_title'), description: t('donation_feature_tax_description') },
    { icon: Heart, title: t('donation_feature_difference_title'), description: t('donation_feature_difference_description') }
  ];

  return (
    <section className="donation-features-section section-padding">
      <div className="container">
        <div className="features-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className={`feature-card fade-up stagger-${index + 1}`}>
                <Icon size={40} className="feature-icon" />
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DonationFeatures;
